module.exports = __webpack_public_path__ + "static/img/img_ser_notify.b6aa069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_ser_notify.png
// module id = WXsn
// module chunks = 1